<template>
    <div>
        <div v-for="(item, index) in list" :key="index + 'listIndex'">
            <div class="ranking-list-item" :class="{ me: isMe }">
                <div class="ranking-num" v-if="isMe">
                    <p>我</p>
                    <p class="color-red">{{ rank(item) }}</p>
                </div>
                <div v-else class="ranking-num">
                    <p v-if="rank(item) > 3">{{ rank(item) }}</p>
                    <div v-else>
                        <van-image class="img" round :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/top${rank(item)}.png`" alt="" />
                    </div>
                    <!-- <img v-else :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/top${rank(item)}.png`" alt=""> -->
                </div>
                <div class="ranking-name">
                    <!-- <van-image class="img" round :src="item?.avatar" error-icon="" /> -->
                    <div>
                        <div>{{ item?.employeeName }}</div>
                        <div class="ellipsis">{{ item?.sectionName }}</div>
                    </div>
                </div>
                <div class="ranking-order">{{ nxNum(item) }}</div>
                <div class="ranking-bonus" v-if="currentJobTab === '3'">
                    <p v-if="item.rank == '1'">
                        {{ item.reward }}
                        <br v-if="item.reward" />
                        <span v-if="item.custflowNetF0Mtd >= item.custflowF0Target && item.custflowNetF0MtdSection >= item.custflowF0TargetSection">盲盒1个</span>
                    </p>
                    <p v-else-if="item.rank == '2' || item.rank == '3'">{{ item.reward }}</p>
                    <p v-else-if="item.custflowNetF0Mtd >= item.custflowF0Target && item.custflowNetF0MtdSection >= item.custflowF0TargetSection">面膜2盒</p>
                </div>
                <div class="ranking-bonus" v-else-if="currentJobTab === '2'">
                    <span v-if="item.archRate10 >= 30">{{ mmbNum(item) }}</span>
                </div>
                <div class="ranking-bonus" v-else>
                    <span v-if="item.archRateAcc >= 100">{{ mmbNum(item) }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'RankingItem',
        props: {
            list: {
                type: Array,
                default: () => []
            },
            dataInfo: {
                type: Object,
                default: function () {
                    return {};
                },
            },
            isMe: {
                type: Boolean,
                default: false
            },
            index: {
                type: Number,
                default: 0
            },
            currentJobTab: {
                type: String,
                default: '1'
            },
            currentGroupTab: {
                type: String,
                default: '第一组'
            }
        },
        computed: {
            rank() {
                return function (item) {
                    if (this.currentJobTab == 1) {
                        return item?.rankAcc
                    }
                    if (this.currentJobTab == 2) {
                        return item?.rank10
                    }
                    if (this.currentJobTab == 3) {
                        return item?.rank
                    }
                }
            },
            nxNum() {
                return function (item) {
                    if (this.currentJobTab == 1) {
                        return item?.archRateAcc ? item?.archRateAcc + '%' : '0%'
                    }
                    if (this.currentJobTab == 2) {
                        return item?.archRate10 ? item?.archRate10 + '%' : '0%'
                    }
                    if (this.currentJobTab == 3) {
                        return item?.custflowNetF0Arch ? item?.custflowNetF0Arch + '%' : '0%'
                    }
                }
            },
            mmbNum() {
                return function (item) {
                    if (this.currentJobTab == 1) {
                        let prize = ''
                        switch (this.currentGroupTab) {
                            case '第一组':
                                prize = item?.rankAcc === '1' ? '新品销售额3% 员工券额' : ''
                                break;
                            case '第二组':
                                prize = item?.rankAcc === '1' || item?.rankAcc === '2' ? '新品销售额3% 员工券额' : ''
                                break;
                            case '第三组':
                                prize = item?.rankAcc === '1' || item?.rankAcc === '2' || item?.rankAcc === '3' ? '新品销售额3% 员工券额' : ''
                                break;
                        }
                        return prize
                    }
                    if (this.currentJobTab == 2) {
                        let prize = ''
                        switch (this.currentGroupTab) {
                            case '第一组':
                                prize = item?.rank10 === '1' ? '青春童颜*6' : ''
                                break;
                            case '第二组':
                                prize = item?.rank10 === '1' || item?.rank10 === '2' ? '青春童颜*3' : ''
                                break;
                            case '第三组':
                                prize = item?.rank10 === '1' || item?.rank10 === '2' || item?.rank10 === '3' ? '青春童颜*2' : ''
                                break;
                        }
                        return prize
                    }
                }
            }
        },
        data() {
            return {

            }
        },
        methods: {
        }
    }
</script>

<style lang='less' scoped>
    .ranking-list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // margin: 10px 0;
        padding: 30px 40px;
        border-bottom: 2px solid #eeeeee;

        &.me {
            padding: 20px;
            margin-top: 30px;
            background-color: #F9F5F0;
            border-radius: 12px;
            border: none;

            .ranking-num {
                text-align: center;

            }
        }

        &.title {
            padding-bottom: 0;
            border: none;
            color: #999999;
        }

        // &:nth-last-child(1) {
        //     border: none;
        // }

        .ranking-num {
            width: 60px;
            margin-right: 30px;

            .color-red {
                color: #AB080B;
            }

            .img {
                width: 50px;
                height: 60px;
            }

            p {
                margin: 0;
                text-align: center;
            }
        }

        .ranking-name {
            display: flex;
            align-items: center;
            width: 260px;

            div {
                width: 100%;
            }

            >.img {
                width: 60px;
                height: 60px;
                min-width: 60px;
                margin-right: 10px;
            }

        }

        .ranking-order {
            width: 160px;
            text-align: center;
        }

        .ranking-bonus {
            width: 180px;
            text-align: center;
        }

        .flagImg {
            width: 65px;
            height: 54px;
        }
    }
</style>
